module.exports = __webpack_public_path__ + "66eca6992527727ff55428ab332068ee.pdf";